var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-h3-2 font-weight-light col col-12 text-left text--primary pa-0 mb-8"},[_c('h5',{staticClass:"font-weight-light"},[_vm._v(" "+_vm._s(_vm.subheading)+" "),(_vm.text)?[_c('span',{staticClass:"text-subtitle-1",domProps:{"textContent":_vm._s(_vm.text)}})]:_vm._e()],2),_c('div',{staticClass:"pt-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }